import React, {Component} from 'react';
import { MODE_BLANC, MODE_SOLUTION, TYPE_THEMATIQUE } from '../../constants';
import QuestionContainer from './question/QuestionContainer';
import ToolboxContainer from "../toolbox/ToolboxContainer";
import QuestionNumberContainer from "../remote/screen/questionnumber/QuestionNumberContainer";
import QuestionNavButtonsContainer from "../solution/nav/buttons/QuestionNavButtonsContainer";
import HelpBoxContainer from "../helpbox/HelpBoxContainer";
import BtnValidateContainer from "./buttons/validate/BtnValidateContainer";
import {faPlusCircle, faMinusCircle} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Comment from "./comment/Comment";
import './Screen.scss';
import MediaQuery from "react-responsive";

class Screen extends Component {

  componentDidMount() {
    const {mode, question, sound, startAudio, showSplashScreen} = this.props;
    if (mode !== MODE_SOLUTION && !showSplashScreen) {
      startAudio(question.id, sound);
    }
  }

  componentDidUpdate(prevProps) {
    const {mode, question, sound, startAudio, showSplashScreen} = this.props;
    const firstOrNextQuestion = (question && !prevProps.question) || question.id !== prevProps.question.id;
    const splashScreenClosed = !showSplashScreen && showSplashScreen !== prevProps.showSplashScreen;

    if (mode !== MODE_SOLUTION && (firstOrNextQuestion || splashScreenClosed)) {
      document.activeElement.blur();
      startAudio(question.id, sound);
    }
  }

  render() {
    const {
      question,
      mode,
      type,
      imagesUrl,
      choices,
      timeLeft,
      totalTime,
      imageFullscreen,
      showSolution,
      showComments,
      validateChoices,
      toggleImageFullscreen
    } = this.props;

    if (!question) {
      return <div>Chargement en cours...</div>;
    }

    // Auto confirm if time's up
    if (timeLeft <= 0 && mode === MODE_BLANC) {
      validateChoices();
    }

    const questions = question.questions.map((q, key) => <QuestionContainer key={key} question={q} showSolution={showSolution} choices={choices}/>);
    const comment = showComments || mode === MODE_SOLUTION ? <Comment content={question.commentaire}/> : null;

    let loader = null;
    if (mode !== MODE_SOLUTION) {
      const width = 100 - ((timeLeft * 100) / totalTime);
      const loaderStyles = { width: width + '%' };
      if(width > 0) {
        loaderStyles.transition = "width 1s";
        loaderStyles.transitionTimingFunction = "linear";
      }
      loader =(
        <div className='loader-container'>
          <div className='loader-progress' style={loaderStyles}></div>
        </div>
      );
    }

    let screenClassName = ['Screen'];
    if (mode === MODE_SOLUTION) {
      screenClassName.push('mode-solution');
    }
    if (type === TYPE_THEMATIQUE) {
      screenClassName.push('type-thematique');
    }

    return (
      <div className={screenClassName.join(' ')}>
        <div>
          <div className="screen-top-container">
            <div className="screen-top-question-number">
              <div>Question</div>
              <QuestionNumberContainer/>
            </div>
            {mode === MODE_SOLUTION ? <QuestionNavButtonsContainer/> : <ToolboxContainer/>}
          </div>
          <div className={'image-fullscreen-container ' + (imageFullscreen ? 'fullscreen' : '') }>
            <div className="image-container">
              <MediaQuery minDeviceWidth={769}>
                {comment}
              </MediaQuery>
              <img src={`${imagesUrl}/${question.image}.jpg`} alt="" className="image" onClick={imageFullscreen ? this.props.toggleImageFullscreen : null}/>
              <div className="icons-container">
                <FontAwesomeIcon icon={imageFullscreen ? faMinusCircle : faPlusCircle} className="icon-search" onClick={toggleImageFullscreen} />
              </div>
              {loader}
            </div>
          </div>
        </div>
        <div>
          {questions}
          <div className="btn-valid-container">
            <BtnValidateContainer/>
            <HelpBoxContainer/>
          </div>
          <MediaQuery maxDeviceWidth={769}>
            {comment}
          </MediaQuery>
        </div>
      </div>
    );
  }
}

export default Screen;
